import React, { useState } from "react";
import Modal from "components/global/modal";
import Button from "components/button/button";
import CropCoverSquare from "./crop-images/crop-cover-square";
import LoadingIndicator from "assets/svg/loading-indicator";

export default function CropCoverModal({ hide, ...props }) {
  const { image, type, returnType, title,updateCoverPhoto = ()=>{} } = props;
  const [cropFile, setCropFile] = useState(null);
  const [cropPreview, setCropPreview] = useState(null);
  const [isLoading, setLoading] = useState(false); 

  const getCropData = async() => {
    if (cropFile) {
      setLoading(true);
      let success = await updateCoverPhoto(cropFile,{media_id:null,status:'gallery'});
      if(success){
        hide({
          imageFile: cropFile,
          preview: `data:${type};base64,${cropPreview}`,
        });
      }
    }
    
    setLoading(false);
  };

  const Footer = () => {
    return (
      <div className="relative grid gap-y-3 1sm:gap-y-0 1sm:flex 1sm:flex-row 1sm:items-center 1sm:justify-end 1sm:space-x-2">
        <Button
          disabled={isLoading}
          buttonName="Cancel"
          buttonClass="bg-thBg py-4 px-8"
          buttonTextClass="text-black text-sm font-semibold"
          onClick={() => hide()}
        />
        <Button
          disabled={isLoading}
          key="save-btn-category"
          buttonName="Save"
          buttonClass="bg-primary py-4 px-10"
          buttonTextClass="text-xs text-white font-semibold flex flex-row items-center gap-2"
          onClick={() => getCropData()}
          icon={
            isLoading ? (
              <LoadingIndicator className="text-white w-4 h-4" />
            ) : null
          }
        />
      </div>
    );
  };

  return (
    <Modal
      footer={<Footer />}
      width="w-19/20 lg:w-1480"
      contentClassName="rounded-lg overflow-auto custom-scroll"
      wrapperClassName="overflow-visible"
      footerClass="border-t border-gray">
      <div className="w-full">
        {/* header */}
        <div className="w-full">
          <div className="pl-10 pr-7 pt-3.5 flex justify-between items-center">
            <p className="text-base 2sm:text-3xl text-lightBlack font-bold tracking-tighter">
              {title || "Edit Thumbnail"}
            </p>
            {/* close */}
            <span className="close" onClick={() => hide()}></span>
          </div>
          <div className="px-10 py-5 w-full">
            <CropCoverSquare
              setParentCrop={setCropFile}
              setCropPreview={setCropPreview}
              image={image}
              type={type}
              returnType={returnType}
              locked={false}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}
